import { lazy } from 'react'

const Dashboard = lazy(() => import('./protected/dashboard'))
const Orders = lazy(() => import('./protected/orders'))
const Vendors = lazy(() => import('./protected/vendors'))
const Applications = lazy(() => import('./protected/applications'))
const ApplicationDetails = lazy(
  () => import('./protected/applications/application-details'),
)
const UserManagement = lazy(() => import('./protected/user-management'))
const NotFound = lazy(() => import('./error/not-found'))
const HelpCenter = lazy(() => import('./protected/help-center'))
const VendorDetails = lazy(() => import('./protected/vendors/vendor-details'))
const Withdrawals = lazy(() => import('./protected/withdrawal'))
const VendorWaitingList = lazy(
  () => import('./protected/waiting-list/vendor-list'),
)
const CustomerWaitingList = lazy(
  () => import('./protected/waiting-list/customer-list'),
)
const Refunds = lazy(() => import('./protected/withdrawal/refunds'))
const PaymentsList = lazy(() => import('./protected/payments/list'))
const Delivery = lazy(() => import('./protected/delivery'))
const CompletedDeliveries = lazy(() => import('./protected/delivery/completed'))
const LiveDeliveryTracking = lazy(
  () => import('./protected/delivery/live-tracking'),
)
const CustomerDetails = lazy(
  () => import('./protected/customers/customer-details'),
)
const CommissionManagement = lazy(() => import('./protected/commissions'))
const CommissionsList = lazy(() => import('./protected/commissions/list'))
const CustomerTransactions = lazy(
  () => import('./protected/transactions/customer-transactions'),
)
const VendorTransactions = lazy(
  () => import('./protected/transactions/vendor-transactions'),
)
const Complaints = lazy(() => import('./protected/complaints'))

export {
  Dashboard,
  Orders,
  Vendors,
  Applications,
  ApplicationDetails,
  UserManagement,
  NotFound,
  HelpCenter,
  VendorDetails,
  Withdrawals,
  VendorWaitingList,
  CustomerWaitingList,
  Refunds,
  PaymentsList,
  Delivery,
  CompletedDeliveries,
  LiveDeliveryTracking,
  CustomerDetails,
  CommissionManagement,
  CommissionsList,
  CustomerTransactions,
  VendorTransactions,
  Complaints,
}
